

import type { IUser } from '@clickster/constant-definitions/dist-esm/entities/user/types';
import { useClicksterStore } from "..";
import { clearFailedRequests , retryFailedRequests as libRetryFailedRequests } from '@/src/lib/axios/auth-event';
import { removeAuthToken } from '@/src/lib/axios/auth-token';

/**
 * This section previously contained loginUser and handleLogin functions,
 * but they have been removed as part of refactoring the authentication flow.
 * The modal now uses direct state management approach without these functions.
 */

// Re-export to maintain compatibility
export const retryFailedRequests = libRetryFailedRequests;

/**
 * Admin role ID constant
 */
export const ADMIN_ROLE_ID = '6920c5f4da6f84cb90444d4a';

/**
 * Check if user has admin role
 */
const checkIsAdmin = (user: IUser | null | undefined): boolean => {
  if (!user?.roles) return false;
  return user.roles.some((role: any) => role.toString() === ADMIN_ROLE_ID);
};

/**
 * Sets the user in the Zustand store with isAdmin flag
 * @param user - User to set in the store
 */
export const setUserStore = (user: IUser | null | undefined) => {
  // Add isAdmin flag to user object
  const userWithAdminFlag = user ? {
    ...user,
    isAdmin: checkIsAdmin(user)
  } : user;

  // Ensure correct setting
  useClicksterStore.setState({ userInSession: userWithAdminFlag as IUser });
};

export const setLoadingUser = (isLoading: boolean) => {
  useClicksterStore.setState({ isLoadingUser: isLoading });
};

export const setShowAuthModal = (show: boolean) => {
  useClicksterStore.setState({ showAuthModal: show });
};

/**
 * Close auth modal without retrying requests
 * Used when user navigates to signin page manually
 */
export const handleCloseForRedirect = () => {
  setShowAuthModal(false);
  clearFailedRequests();
};

/**
 * Log out the current user
 */
export const logoutUser = () => {
  removeAuthToken();
  setUserStore(null);
};
